// web
export { default as Signup } from './web/Signup';
export { default as Activate } from './web/Activate';
export { default as SetupAccount } from './web/SetupAccount';
export { default as ForgotPassword } from './web/ForgotPassword';
export { default as PasswordReset } from './web/PasswordReset';
export { default as Login } from './web/Login';
export { default as Account } from './web/Account';

// form
export { default as SignupWelcome } from './signup/Welcome';
export { default as SignupMain } from './signup/Main';
export { default as SignupComplete } from './signup/Complete';


// static pages
export { default as Faqs } from './web/Faqs';

// us tradeshow
export { default as SignupUS } from './web/SignupUS';

// new contract
export { default as Contract } from './web/Contract';



// WEBPACK FOOTER //
// ./client/redesign/index.js